var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8922 12.2735C21.8922 17.4198 17.7203 21.5917 12.574 21.5917C7.42775 21.5917 3.25586 17.4198 3.25586 12.2735C3.25586 7.12721 7.42775 2.95532 12.574 2.95532C17.7203 2.95532 21.8922 7.12721 21.8922 12.2735Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.574 21.5463C17.6952 21.5463 21.8467 17.3948 21.8467 12.2736C21.8467 7.1524 17.6952 3.00085 12.574 3.00085C7.45281 3.00085 3.30127 7.1524 3.30127 12.2736C3.30127 17.3948 7.45281 21.5463 12.574 21.5463Z",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.574,
    cy: 12.2735,
    r: 9.81818,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5737 21.0236C10.8431 21.0236 9.15142 20.5104 7.71249 19.5489C6.27356 18.5875 5.15206 17.2209 4.48979 15.622C3.82752 14.0232 3.65424 12.2639 3.99186 10.5665C4.32948 8.86919 5.16284 7.31009 6.38655 6.08638C7.61026 4.86267 9.16936 4.02931 10.8667 3.69169C12.564 3.35407 14.3234 3.52735 15.9222 4.18962C17.5211 4.85188 18.8876 5.97339 19.8491 7.41232C20.8106 8.85125 21.3237 10.543 21.3237 12.2736C21.3212 14.5934 20.3985 16.8175 18.7581 18.4579C17.1177 20.0983 14.8936 21.021 12.5737 21.0236ZM7.68248 11.0398L6.44873 12.2736L10.8237 16.6486L18.6987 8.77356L17.465 7.53106L10.8237 14.1723L7.68248 11.0398Z",
    fill: "#146EAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckActive);
export default __webpack_public_path__ + "static/media/iconCheckActive.c05e66afe09d9484229961f252cb3f60.svg";
export { ForwardRef as ReactComponent };